import React, { useEffect } from "react";
import styled from "styled-components";
import { useLocation } from "react-router-dom";
import DirectoryTabs from "../../../components/AdminCentral/Directory/DirectoryTabs";
import OrganizationSearchContent from "../../../components/AdminCentral/Directory/OrganizationSearchContent";
import UserSearchContent from "../../../components/AdminCentral/Directory/UserSearchContent";
import usePersistentTabState from "../../../hooks/usePersistentTabState";

const breakpoints = {
  tablet: 768,
  phone:  480,
};


const DashboardContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  padding: 20px;
  min-height: 100vh;
  background-color: transparent;
`;

const Container = styled.div`
  width: 1100px;
  align-items: center;
  padding: 20px;
  // margin: 20px;
  font-family: Arial, sans-serif;
  border-radius: 5px;
  background-color: ${(props) => props.colors.cardBackground}; 
   @media (max-width: ${breakpoints.tablet}px) {
    width: 750px;
    padding: 16px;
  }

  @media (max-width: ${breakpoints.phone}px) {
    width: 350px;
    // padding: 12px;
    margin: 0 auto;
    overflow-x: auto;
    -webkit-overflow-scrolling: touch;
  }
`;

const Title = styled.text`
 font-size: 36px;
  color: ${({ colors }) => colors.titleText};
  font-weight: 600;
  margin-bottom: 20px; 
  #span {
    display: block;
    color: black;
    font-size: 16px;
    margin-top: 20px;
    margin-bottom: 10px;
  }
`;

const TABS = ["Organization Search", "User Search"];

const DirectoryPage = ({ colors }) => {
  const [selectedTab, setSelectedTab] = usePersistentTabState(
    "admincentral.directory.selectedTab",
    TABS[0]
  );
  const location = useLocation();
  const initialTab = location?.state?.initialTab;

  useEffect(() => {
    if (initialTab && initialTab !== selectedTab && TABS.includes(initialTab)) {
      setSelectedTab(initialTab);
    }
  }, [initialTab, selectedTab, setSelectedTab]);

  useEffect(() => {
    if (!TABS.includes(selectedTab)) {
      setSelectedTab(TABS[0]);
    }
  }, [selectedTab, setSelectedTab]);

  const handleTabClick = (tab) => {
    setSelectedTab(tab);
  };

  return (
    <DashboardContainer>
    <Title colors={colors}> Directory </Title>
    <Container colors={colors}>
      <DirectoryTabs colors={colors} selectedTab={selectedTab} handleTabClick={handleTabClick} />
      {selectedTab === "Organization Search" && <OrganizationSearchContent colors={colors} />}
      {selectedTab === "User Search" && <UserSearchContent colors={colors} />}
    </Container>
    </DashboardContainer>
  );
};

export default DirectoryPage;
